export enum EnvironmentNameEnum {
  QA = 'QA',
  LOCAL = 'Local',
  DEV = 'Development',
  PROD = 'Production',
  STAGING = 'Staging',
}
